var _style, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvantiAmberKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 460 460",
    style: {
      enableBackground: "new 0 0 460 460"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004F59;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FF4713;}\n\t.st3{fill:#752420;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KEY"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "MAP"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 230,
    cy: 230,
    r: 160
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "290,229.68 281.75,237.9 230.17,186.14 178.22,237.91 170,229.67 230.2,169.67  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "290,262.08 281.75,270.3 230.17,218.54 178.22,270.31 170,262.07 230.2,202.08  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvantiAmberKey);
export default __webpack_public_path__ + "static/media/avanti-amber-key.9df32f275a8fddd29e3a67842a9e7761.svg";
export { ForwardRef as ReactComponent };